import { api } from './api'

export interface ExtractedFileText {
  work_description: string
  filename: string
  char_count: number
}

/**
 * 파일에서 작업 설명 텍스트 추출 — TBM/RA/WorkPermit 의 파일 업로드 모드에서 사용.
 * 백엔드 /api/files/extract-text (PDF/DOCX/TXT) 호출.
 */
export async function extractFileText(file: File): Promise<ExtractedFileText> {
  const formData = new FormData()
  formData.append('work_file', file)
  const { data } = await api.post<ExtractedFileText>('/files/extract-text', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120_000,
  })
  return data
}
